var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.54 139.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-13,.cls-15,.cls-20,.cls-21,.cls-24,.cls-27,.cls-31,.cls-33,.cls-35,.cls-36,.cls-38,.cls-39,.cls-7{fill:none;}.cls-1,.cls-38,.cls-39{stroke:#202020;}.cls-1,.cls-10,.cls-11,.cls-13,.cls-15,.cls-20,.cls-21,.cls-24,.cls-27,.cls-33,.cls-35,.cls-36,.cls-7{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-7{stroke-width:0.75px;}.cls-2{fill:#202020;}.cls-3{fill:#f59b79;}.cls-4{fill:#f06733;}.cls-5{fill:#ffc4ad;}.cls-6{fill:#ebe0fd;}.cls-11,.cls-15,.cls-33,.cls-35,.cls-7{stroke:#000;}.cls-8{fill:#bbf0f9;}.cls-9{fill:#3acddd;}.cls-10,.cls-21{stroke:#fff;}.cls-10,.cls-27{stroke-width:2px;}.cls-11,.cls-38{stroke-width:0.5px;}.cls-12{fill:#b994fc;}.cls-13{stroke:#dbc7ff;}.cls-14{fill:#dbc7ff;}.cls-15,.cls-39{stroke-width:0.25px;}.cls-16{fill:#ff61bf;}.cls-17,.cls-18{fill:#c3268a;}.cls-18,.cls-19{opacity:0.5;}.cls-20{stroke:#f3a0ca;stroke-width:1.5px;}.cls-22{fill:#f8c5a6;}.cls-23{fill:#ffe5d5;}.cls-24{stroke:#f57a59;}.cls-25{fill:#ffe6d7;}.cls-26{fill:#f57a59;}.cls-27{stroke:#9b63ff;}.cls-28{fill:#fff;}.cls-29{fill:#9b63ff;}.cls-30{fill:#fbb63a;}.cls-31{stroke:#d08600;}.cls-31,.cls-38,.cls-39{stroke-miterlimit:10;}.cls-32{fill:#ee4517;}.cls-34{fill:#ff9a80;}.cls-35{stroke-width:0.26px;}.cls-36{stroke:#c3268a;}.cls-37{fill:#ff3838;}.cls-40{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,64.36l8.47-12.71L32.33,58l9.05-9.89,19,4.62L74.72,37.37s4.48,4.34,4.78,4S90.17,28.15,90.17,28.15"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89.39,
    cy: 28.57,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.73,11.79V79.46h94.64V11.79ZM98.54,75.53h-87V15.72h87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.52,
    y: 75.53,
    width: 76.8,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7.73,
    y: 11.79,
    width: 1.44,
    height: 67.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11.87,
    y: 16.1,
    width: 2.08,
    height: 59.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 54.57,
    y: -25.65,
    width: 2.08,
    height: 85.57,
    transform: "translate(72.75 -38.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 7.73,
    y1: 68.63,
    x2: 7.73,
    y2: 53.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "7.73 24.35 7.73 11.79 102.37 11.79 102.37 79.46 7.73 79.46 7.73 71.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 7.73,
    y1: 48.98,
    x2: 7.73,
    y2: 32.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 11.56,
    y: 15.72,
    width: 86.99,
    height: 59.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "155.16 82.08 87.71 82.08 87.71 35.66 94.82 34.66 156.16 34.66 155.16 82.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "155.16 82.08 87.71 82.08 87.71 79.59 94.82 79.59 155.16 79.59 155.16 82.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "96.15 49.32 96.44 35.63 148.23 35.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94.53 82.08 88 82.08 88 35.9 95.53 34.66 94.53 82.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.61,41a18.4,18.4,0,0,1,.7-1.73,3.92,3.92,0,0,1,1.09-1.52h0a16.71,16.71,0,0,1-.93,1.6c-.31.54-.58,1.09-.86,1.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.24,40a9.07,9.07,0,0,1,.41-1.55,2.85,2.85,0,0,1,.85-1.37h0s0,0,0,0a13.58,13.58,0,0,1-.68,1.44A10.53,10.53,0,0,0,89.27,40h0S89.24,40,89.24,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,79.53a17.33,17.33,0,0,1-.72-1.72A3.89,3.89,0,0,1,90.83,76h0a16.32,16.32,0,0,1,.48,1.79c.16.59.36,1.18.56,1.77a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.91,79.09a7.42,7.42,0,0,1-.81-1.39,2.79,2.79,0,0,1-.37-1.57h0a13.86,13.86,0,0,1,.52,1.49,12.72,12.72,0,0,0,.65,1.46,0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.1,82.08H88.58a.87.87,0,0,1-.87-.87V36.37a.81.81,0,0,1,.71-.81l6.4-.9H155.1a1.06,1.06,0,0,1,1.06,1.06l-1,45.29A1.07,1.07,0,0,1,154.1,82.08Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 94.53,
    y1: 82.08,
    x2: 95.53,
    y2: 34.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 95.03,
    y1: 78.72,
    x2: 101.57,
    y2: 78.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 103.32,
    y1: 78.72,
    x2: 104.11,
    y2: 78.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 11.49,
    y1: 20.13,
    x2: 18.03,
    y2: 20.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 19.78,
    y1: 20.13,
    x2: 20.57,
    y2: 20.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 95.53,
    y1: 40.45,
    x2: 104.57,
    y2: 40.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 106.32,
    y1: 40.45,
    x2: 108.37,
    y2: 40.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 95.53,
    y1: 38.11,
    x2: 111.57,
    y2: 38.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 11.76,
    y1: 13.69,
    x2: 27.81,
    y2: 13.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 98.1,
    y1: 22.09,
    x2: 95.05,
    y2: 22.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 93.3,
    y1: 22.09,
    x2: 91.25,
    y2: 22.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 98.1,
    y1: 19.75,
    x2: 88.05,
    y2: 19.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.34,81.54a.3.3,0,0,1-.13,0,.48.48,0,0,1-.35-.61c.09-.34,2.36-8.37,7.57-10.83a.51.51,0,0,1,.67.24.5.5,0,0,1-.24.67c-4.8,2.26-7,10.11-7,10.19A.49.49,0,0,1,112.34,81.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.75,71.44h0c-5.68,0-10.28,17.48-10.28,23V95H131v-.51C131,88.92,126.43,71.44,120.75,71.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.48,71.07h0c-5.53,0-10,17.48-10,23v.51h20v-.51C130.48,85,126,71.07,120.48,71.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.27,82.83c0,2.5-1.25,4.53-2.8,4.53a1.81,1.81,0,0,1-.82-.2c1.14-.57,2-2.29,2-4.33s-.83-3.76-2-4.33a1.81,1.81,0,0,1,.82-.2C122,78.3,123.27,80.33,123.27,82.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 120.48,
    cy: 82.83,
    rx: 2.79,
    ry: 4.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 109.19,
    y1: 94.59,
    x2: 109.19,
    y2: 97.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.01,
    y: 94.59,
    width: 36.18,
    height: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 101.01,
    y: 94.59,
    width: 8.18,
    height: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.01,
    y: 94.59,
    width: 36.18,
    height: 3.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 109.19,
    y1: 94.59,
    x2: 109.19,
    y2: 97.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M51.83,3.41S48.91-.47,41.85.55c-5.13.73-7.91,6.73-8.64,10.17s-2.52,7.85-4.93,14.89-.66,10.12,1.93,13.29,2.14,8.86,2.14,8.86c1.07,9.54,9.16,10.72,9.16,10.72S52.7,60.23,58,59.72a10.65,10.65,0,0,0,4.5-.86c3.08-1.43,4.89-5.46,5.06-8.86a23.42,23.42,0,0,1,.73-5.84,31.7,31.7,0,0,0,1.9-9.93c-.07-3-1.53-5.7-1.46-7.89s2-5.18,1.53-10.22a17.63,17.63,0,0,0-8-13.56c-4.11-2.7-9.11-1.15-11.19-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55.65,2.07s11.76-1.69,14,15.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M56.69,59.94a112.35,112.35,0,0,1-14.75-1.32s-8.08-1.18-9.15-10.72a28,28,0,0,0-2.14-8.85c-1.83-3.67-4.35-6.24-1.94-13.29s4.2-11.47,4.93-14.9S36.42,1.32,41.56.59A15.57,15.57,0,0,1,44.45.51c-.44,0,0,0-2.32.87C37.28,3.2,35.76,7.43,35,10.86s-2.52,7.85-4.93,14.9S29.44,35.87,32,39.05s2.14,8.85,2.14,8.85c1.07,9.54,9.15,10.72,9.15,10.72A123.56,123.56,0,0,0,56.69,59.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,43.5A15.58,15.58,0,0,1,32.78,46a23.06,23.06,0,0,0,.14,2.38,12.6,12.6,0,0,0,1.39,4.43,9.67,9.67,0,0,0,3.09,3.42,13.55,13.55,0,0,0,2,1.13c.36.16.72.3,1.09.43l.56.17.28.08.15,0,.08,0h0a.62.62,0,0,1,.23.14l-.3-.14c2,.27,3.92.56,5.89.78s3.91.31,5.86.45a39.08,39.08,0,0,0,5.83-.08,11.85,11.85,0,0,0,2.8-.53,6.31,6.31,0,0,0,2.33-1.47,10.25,10.25,0,0,0,2.71-5c.48-1.85.25-3.83.48-5.84.06-.5.13-1,.24-1.5s.28-1,.42-1.46c.29-.93.57-1.87.81-2.81a25.42,25.42,0,0,0,.89-5.72,18.88,18.88,0,0,0-1-5.67,9.79,9.79,0,0,1-.45-3,14.84,14.84,0,0,1,.7-3,17.59,17.59,0,0,0,1-5.68,19.24,19.24,0,0,0-1-5.68,17,17,0,0,0-7-9,9.39,9.39,0,0,0-5.4-1.48,15.25,15.25,0,0,0-5.59,1.25A.36.36,0,0,1,50.85,2,16.16,16.16,0,0,1,56.71.67a10.06,10.06,0,0,1,5.83,1.6,17.88,17.88,0,0,1,7.23,9.35,20.16,20.16,0,0,1,1,5.91,19.56,19.56,0,0,1-.86,5.95,14.08,14.08,0,0,0-.65,2.76A9.08,9.08,0,0,0,69.7,29a19.36,19.36,0,0,1,1,5.92,28.06,28.06,0,0,1-.91,5.93c-.24,1-.52,1.91-.82,2.86a15.31,15.31,0,0,0-.67,2.79c-.13,1-.21,1.92-.28,2.91a13.86,13.86,0,0,1-.45,3,12.13,12.13,0,0,1-2.81,5.32,7.33,7.33,0,0,1-2.57,1.73,14.84,14.84,0,0,1-3,.65,38.42,38.42,0,0,1-6,.11c-2-.05-4-.3-5.91-.54s-4-.52-5.82-.77l-.3-.15a.31.31,0,0,0,.16.12h0l-.07,0-.14,0-.3-.08-.6-.18c-.39-.14-.78-.29-1.16-.46a10.82,10.82,0,0,1-2.17-1.23,11.55,11.55,0,0,1-3.33-3.69,11.77,11.77,0,0,1-1.44-4.74c-.08-.82-.09-1.67-.11-2.44a15.35,15.35,0,0,0-.25-2.35.36.36,0,0,1,.29-.42A.36.36,0,0,1,32.5,43.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59,3.63a7,7,0,0,0-2.73-1.88A11.25,11.25,0,0,0,45.57.89,14.07,14.07,0,0,0,42.14,1,7.06,7.06,0,0,0,39,2,8,8,0,0,0,36.58,4.3a14.53,14.53,0,0,0-1.73,3,22,22,0,0,0-1.13,3.26c-.28,1.14-.64,2.3-1,3.42-.76,2.24-1.39,4.52-2.17,6.74s-1.64,4.44-2.28,6.66-1.15,4.56-.43,6.73,2.47,3.83,3.53,6h0a.36.36,0,1,1-.64.31c-1-2-2.84-3.72-3.59-6.13a10.68,10.68,0,0,1-.37-3.64,14.22,14.22,0,0,1,.63-3.56c.72-2.29,1.5-4.49,2.29-6.72s1.78-4.37,2.43-6.62a30.76,30.76,0,0,0,.82-3.41A17.21,17.21,0,0,1,34,6.89a16,16,0,0,1,1.8-3.16,11.5,11.5,0,0,1,2.73-2.47A8,8,0,0,1,42,.11a15.65,15.65,0,0,1,3.62,0,9.65,9.65,0,0,1,6.5,3.1.36.36,0,0,1,0,.5.35.35,0,0,1-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37,53a9.66,9.66,0,0,1-1.75-4.83c-.06-.85,0-1.72-.06-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.7,52.16a6.37,6.37,0,0,1-1.49-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M73.92,84.58a11.9,11.9,0,0,1-2.16-3.28C70.62,79,69,75.42,66.51,70.93s-3.82-7.35-4.82-9.52-1.43-3.89-2.81-5.71c-2.73-3.61-6.86-3.38-9.19-3.26s-6.17,2.74-6.17,2.74C36.08,61.8,19.21,81.54,19.21,81.54L15.31,91H23.2l1.46-4.58S36.86,74.7,36.8,74.54l-.75-1.67c3.51,6.33,3.31,24.54,3.31,24.54H58.45l3.13-19.47a53.34,53.34,0,0,0,4,10.32c.81,1.61,2.65,2.41,4.1,4.12l1.32.93L75.22,95l4.86.63,5.11-.39.44-1.38c0-.16.54-1.42.54-1.42l.6-1S86,91,85.92,91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M85.37,94.11c-.13.39-.37,1.18-.37,1.18l-5.12.39L75,95.05l-4.19-1.72L69.5,92.4c-1.44-1.71-3.29-2.51-4.1-4.12-.49-1-.93-1.9-1.31-2.78C66.59,88.38,74.32,95.93,85.37,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M40.67,95.68l-1,0A74,74,0,0,0,37,74.91a4.61,4.61,0,0,1-.21-.94h.5l.5,0c0,.08.08.34.18.73A74.94,74.94,0,0,1,40.67,95.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M61.16,77.71,58.33,97H39.24v-.88C46.45,94.07,55.5,93.89,57.32,83,57.68,80.86,60,79.56,61.16,77.71Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "17.27 88.87 19.9 82.37 26.98 74.29 26.57 73.97 29.77 70.5 36.99 62.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "26.12 85.01 35.93 73.42 36.47 74.28 36.47 74.91 34.91 77.1 26.12 85.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 36.05,
    y1: 63.66,
    x2: 42.13,
    y2: 57.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,74.24l0,1.49-.1,1.52-.37,3-.87,5.87c-.62,3.91-1.16,7.83-1.75,11.74a.34.34,0,0,1-.33.29c-1.59,0-3.18,0-4.77,0l-4.77,0c-3.18,0-6.36.1-9.55.07a.32.32,0,0,1-.32-.33c0-4.14-.17-8.29-.56-12.41-.2-2.06-.47-4.11-.85-6.14a21.33,21.33,0,0,0-1.8-5.86h0a.25.25,0,0,1,.11-.34.25.25,0,0,1,.34.11,21,21,0,0,1,1.95,6,61.72,61.72,0,0,1,.9,6.2c.4,4.15.57,8.31.56,12.48l-.33-.33c3.19,0,6.37.09,9.55.08l4.77,0c1.59,0,3.18-.06,4.77-.06l-.33.29c.56-3.92,1.17-7.83,1.69-11.75l.86-5.88.49-2.93.13-1.43V74.24a.28.28,0,0,1,.28-.27A.27.27,0,0,1,61.85,74.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.51,65.29c2.7-3,5.37-5.87,7.61-8.1A15.69,15.69,0,0,1,48,53.1a7.68,7.68,0,0,1,1.66-.3c2.33-.12,6-1.18,8.7,2.42a21.24,21.24,0,0,1,2.88,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.22,71.29c.87-1,1.76-2,2.67-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19,91.34h-3.7l3.9-9.45s3.07-3.7,7.17-8.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.63,75.11c.06.16-12,11.65-12,11.65L23.2,91.34H20.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M37.51,24s-.34,9.59,2.72,15.43,6.58,9.11,11.3,9.11,10.18-3.18,11.44-11c.86-5.32,2-6,1.65-16.06,0,0-10.75-3.75-12.51-14.66,0,0-4.67,17.14-18.6,17.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.84,47.61c-2.83-1.33-5.18-4.15-7.31-8.22C37.47,33.55,37.8,24,37.8,24l-4,0a15.34,15.34,0,0,0,7.3-1.8C40.55,27.94,40.28,40.85,47.84,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M52,8.52s1.58,8.79,12.1,13.42c0,0,.58,18.11-5.88,23.36"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 40.9,
    cy: 27.32,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 42.33,
    cy: 25.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 42.74,
    cy: 24.17,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 41.45,
    cy: 24.35,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 41.22,
    cy: 30.29,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 42.37,
    cy: 28.67,
    r: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M37.49,28.1a2.88,2.88,0,0,0-2.05-1.51,2.85,2.85,0,0,0-2.47.3,2.86,2.86,0,0,0-.79,2.8c.18,1,.63,1.95.79,3s.09,2.26.91,2.9a2.28,2.28,0,0,0,2.4,0c.75-.39,1.37-1,2.12-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M35.05,35.33c-1.15-.72-1-2.42-1.31-3.62-.46-1.54-1.72-4.19.82-4.6.47-.08.27-.8-.2-.73-2.11.34-2.32,2.12-1.86,3.93.18.73.5,1.41.67,2.14s0,1.27.14,1.94c.15.83.67,1.16,1.36,1.59.41.26.79-.39.38-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M34.28,22.91s11,.95,16.57-15.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M38.94,20.92a19.82,19.82,0,0,0,9.16-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.85,20.74a20.93,20.93,0,0,0,5.35-4A19.17,19.17,0,0,0,48,11.22a.15.15,0,0,1,.19-.07.14.14,0,0,1,.07.19A20.22,20.22,0,0,1,44.5,17,18.56,18.56,0,0,1,39,21.1a.2.2,0,0,1-.18-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.88,16.46a12.33,12.33,0,0,0,2.67-2.21,12.62,12.62,0,0,0,1.91-2.91.15.15,0,0,1,.21-.07.16.16,0,0,1,.07.21,13.58,13.58,0,0,1-1.9,3,12.39,12.39,0,0,1-2.72,2.34.22.22,0,0,1-.31-.07.22.22,0,0,1,.06-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M52.7,6.82c0,.15.93,9.06,12,13.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M69.89,5l.34-.11c.91-.3.52-1.75-.4-1.45l-.33.11c-.92.3-.53,1.75.39,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M29.71,33.65c-.74-1.54-.3-3.94,0-5.56.09-.47-.63-.67-.72-.2-.37,1.89-.8,4.34.06,6.14.21.43.86,0,.65-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M29.57,35.48a7.89,7.89,0,0,0,.65,1.13c.28.4.93,0,.65-.38a7,7,0,0,1-.65-1.13c-.21-.43-.86-.05-.65.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M34.22,15a20.26,20.26,0,0,0,1.4-4.83c.09-.47-.63-.67-.72-.2a19.78,19.78,0,0,1-1.33,4.65c-.2.43.45.82.65.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M36.12,8.53a4,4,0,0,1,.4-1.08c.24-.42-.41-.8-.64-.38a4.69,4.69,0,0,0-.48,1.26c-.1.47.62.67.72.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.48,29.58C35,30.3,35.6,31,36.2,31.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.2,29.58c-.55.72-1,1.94-1.56,2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M45.34,20.86a3.85,3.85,0,0,0,.67-.47c.37-.31-.16-.84-.53-.53a2.63,2.63,0,0,1-.52.35c-.42.23,0,.88.38.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M47.27,19.24a17.07,17.07,0,0,0,3.55-5c.21-.44-.44-.82-.65-.38a16.65,16.65,0,0,1-3.43,4.81c-.34.33.19.87.53.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M38.57,31.9a3.37,3.37,0,0,0,0,.71c.06.48.81.48.75,0a3.37,3.37,0,0,1,0-.71c0-.49-.72-.48-.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M38.89,34.4a17.66,17.66,0,0,0,2.27,5.67c.26.41.9,0,.65-.38a16.85,16.85,0,0,1-2.19-5.49c-.1-.47-.82-.27-.73.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M38.49,34.75a29.65,29.65,0,0,0,1.57,4.5,24.07,24.07,0,0,0,2.32,4.15,14,14,0,0,0,3.23,3.42A10.8,10.8,0,0,0,49.9,48.6h0a.38.38,0,0,1,.3.44.39.39,0,0,1-.44.3,11.9,11.9,0,0,1-4.62-1.91,17.79,17.79,0,0,1-3.54-3.5,22.67,22.67,0,0,1-2.48-4.29A27.58,27.58,0,0,1,37.51,35a.51.51,0,0,1,.37-.6.5.5,0,0,1,.6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M65.7,26.32a45,45,0,0,1-.44,6.57,34.73,34.73,0,0,1-1.48,6.42,20.35,20.35,0,0,1-3.13,5.84,10.74,10.74,0,0,1-5.5,3.71.37.37,0,0,1-.46-.26.38.38,0,0,1,.26-.47h0a9.78,9.78,0,0,0,5.1-3.46A15.51,15.51,0,0,0,61.74,42a26.1,26.1,0,0,0,1.16-3,36.07,36.07,0,0,0,1.39-6.26,43.12,43.12,0,0,0,.41-6.41v0a.5.5,0,1,1,1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M37.49,28.1a2.88,2.88,0,0,0-2.05-1.51,2.85,2.85,0,0,0-2.47.3,2.86,2.86,0,0,0-.79,2.8c.18,1,.63,1.95.79,3s.09,2.26.91,2.9a2.28,2.28,0,0,0,2.4,0c.75-.39,1.37-1,2.12-1.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 54.94,
    y1: 29.58,
    x2: 56.69,
    y2: 35.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M50.28,46.65c-.07,0-.71,5.08-1.05,7.84a2.8,2.8,0,0,0,2.33,3.14h.07a2.78,2.78,0,0,0,3-2.68l.4-7.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.2,48.76a12.23,12.23,0,0,0,3.42.77l.78,5.92L55,47.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50,48.37c-.07,0-.53,3.81-.8,6.12a2.8,2.8,0,0,0,2.33,3.13h.07a2.79,2.79,0,0,0,3-2.68l.35-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.51,24s-.34,9.59,2.72,15.43,6.58,9.11,11.3,9.11a11.15,11.15,0,0,0,10-6.51c1.73-3.52,2.48-9,2.79-11.42a53.81,53.81,0,0,0,.25-9.14S53.87,17.68,52.11,6.77c0,0-4.67,17.14-18.6,17.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.64,78.26c.88,2.81,3.07,9.38,4.76,11.07,2.19,2.19,3.72,5.4,12.12,6.2a22.94,22.94,0,0,0,6.79-.29,9.14,9.14,0,0,1,1.46-3.72L74.5,85.16l-1.9-1.9L61.74,61.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "55.58 55.6 56.69 58.27 55.05 59.44 50.85 59.25 47.2 57.05 48.5 54.83 51.73 56.13 55.58 55.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M48.1,54.43s2.27,3,8,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M14.42,97.43l-.88-8.23s9.06.19,11.49,1.07l-1.46,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M22.86,96.78c.19-.19,1.31-5.92,1.31-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.42,97.43l-.88-8.23s9.06.19,11.49,1.07l-1.46,7.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 13.99,
    y1: 92.23,
    x2: 21.86,
    y2: 92.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 89.32,
    cy: 92.93,
    r: 4.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M93.8,93.31a4.48,4.48,0,0,1-4.48,4.48,4.36,4.36,0,0,1-.51,0,4.47,4.47,0,0,0,0-8.89,4.36,4.36,0,0,1,.51,0A4.48,4.48,0,0,1,93.8,93.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 89.32,
    cy: 93.29,
    r: 4.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 87.71,
    cy: 92.09,
    rx: 1.53,
    ry: 1.31,
    transform: "translate(-30.77 138.32) rotate(-67.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14.83,89.36c0,.1.11,1.3.11,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M15.92,89.36c0,.1.11,1.3.11,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M19,89.36c0,.1-.18,1.5-.18,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20.22,89.46c0,.1-.18,1.5-.18,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M21.52,89.55c0,.09-.18,1.49-.18,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M22.86,89.69c0,.09-.18,1.49-.18,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.75,90c0,.09-.18,1.49-.18,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M17.27,89.36c0,.1.11,1.3.11,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.57,74.49a5.1,5.1,0,0,0,4.74,2.81,11.7,11.7,0,0,0,5.52-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M55.73,76.44a12.6,12.6,0,0,0,4.64-2.64,6.17,6.17,0,0,0,2-4.78c-.15-2-1.54-3.74-2.67-5.46a24.06,24.06,0,0,1-2.4-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.1,26.42a4.15,4.15,0,0,0-2.92-.74A5,5,0,0,0,45.44,27a2.27,2.27,0,0,1-.84.61,1,1,0,0,1-1.22-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45,27.21a1,1,0,0,1-.33-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M57,26.1a2.06,2.06,0,0,1,.81-.82,3.26,3.26,0,0,1,1.7-.57,4.24,4.24,0,0,1,1.58.4,4.55,4.55,0,0,0,1.57.44A1.53,1.53,0,0,0,64,24.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M61.4,25.18a2.26,2.26,0,0,0,1-.24,1,1,0,0,0,.51-.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M17.56,96.73a2.69,2.69,0,0,1,.54.77,3.2,3.2,0,0,1,0,1,1.62,1.62,0,0,0,3,.84,1.69,1.69,0,0,0,0-1.7V97.5a.68.68,0,0,0-.11-.31c-.14-.19-.42-.24-.58-.41s-.09-.75-.05-1.15A1.58,1.58,0,0,0,19.31,94a1.71,1.71,0,0,0-1.85.72A1.84,1.84,0,0,0,17.56,96.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 9.89,
    y: 103.61,
    width: 123.66,
    height: 35.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 9.89,
    y: 103.61,
    width: 123.66,
    height: 4.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 9.89,
    y: 103.61,
    width: 123.66,
    height: 35.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 20.42,
    y1: 101.57,
    x2: 23.66,
    y2: 101.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 0.5,
    y: 97.57,
    width: 144.01,
    height: 8.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 0.55,
    y: 103.61,
    width: 143.92,
    height: 1.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M63.46,100.74H.55V97.57H66.64A3.18,3.18,0,0,1,63.46,100.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.55,
    y1: 101.57,
    x2: 16.78,
    y2: 101.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 19.41,
    y1: 101.57,
    x2: 21.53,
    y2: 101.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1.45,
    y1: 98.65,
    x2: 54.42,
    y2: 98.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 0.5,
    y: 97.57,
    width: 144.01,
    height: 8.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 16.78,
    y1: 105.58,
    x2: 16.78,
    y2: 138.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 127.1,
    y1: 105.58,
    x2: 127.1,
    y2: 138.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M12.23,112.82A15.15,15.15,0,0,1,14,109.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M11.87,111.83a8.55,8.55,0,0,1,1.26-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,118.36a17,17,0,0,1,.71-1.73,3.79,3.79,0,0,1,1.08-1.52h0s0,0,0,0a18,18,0,0,1-.92,1.6c-.31.53-.58,1.09-.87,1.65h0S100.87,118.37,100.87,118.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,117.38a7.8,7.8,0,0,1,.41-1.56,2.87,2.87,0,0,1,.85-1.37h0a13.47,13.47,0,0,1-.69,1.43,12.72,12.72,0,0,0-.57,1.49,0,0,0,0,1,0,0S100.5,117.39,100.51,117.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M14,135.85a14.56,14.56,0,0,1-.53-3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M13.06,135.28a8.71,8.71,0,0,1-.75-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M23.44,130.12a14.85,14.85,0,0,1-1.76-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M22.42,129.9a8.73,8.73,0,0,1-1.78-2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,133.83c-.37-.49-.74-1-1.07-1.53a3.78,3.78,0,0,1-.69-1.74h0c.32.55.59,1.09.85,1.65s.6,1.08.92,1.62a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,133.6a8.16,8.16,0,0,1-1.09-1.18,2.87,2.87,0,0,1-.69-1.46s0,0,0,0h0c.31.45.57.89.83,1.35a10.61,10.61,0,0,0,.94,1.29h0S104.44,133.61,104.44,133.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12.88 87.62 12.16 88.36 11.74 86.78 12.88 86.9 12.88 87.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 14.2,
    cy: 87.36,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 10.26,
    cy: 87.57,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11.52,
    cy: 89.14,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11.87,
    cy: 85.5,
    r: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M62.43,78.11s2.27,7.39,3.87,9.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M51,38.71a2.79,2.79,0,0,0,4.14.38.65.65,0,0,0,.52.2,1.39,1.39,0,0,0,.67-.2s1.08,1.12,2.72-.47c0,0-.89,3.94-4,3.91a3.8,3.8,0,0,1-4-3.16C51,38.62,51,38.71,51,38.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M51,38.71a2.79,2.79,0,0,0,4.14.38.65.65,0,0,0,.52.2,1.08,1.08,0,0,0,.67-.33s1.08,1.25,2.72-.34c0,0-.89,3.94-4,3.91a3.8,3.8,0,0,1-4-3.16C51,38.62,51,38.71,51,38.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M51.28,39.22s4,4.34,7.44,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 110.91,
    y1: 91.9,
    x2: 119.96,
    y2: 91.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 121.71,
    y1: 91.9,
    x2: 123.76,
    y2: 91.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M42.73,10.9a3.43,3.43,0,0,0,1-2.62,2.46,2.46,0,0,0-1.9-2.06A2.76,2.76,0,0,0,39.41,7a3.78,3.78,0,0,0-1.1,2.34A4.94,4.94,0,0,1,38,11.08a6.77,6.77,0,0,1-1,1.12,1.21,1.21,0,0,0-.26,1.35c.3.47,1,.46,1.54.29a8.15,8.15,0,0,0,2.59-1.61A5.81,5.81,0,0,0,42.73,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41.22,12.85c-.86.22-1.43.89-1.27,1.5s1,.92,1.84.7,1.43-.89,1.27-1.5A1.44,1.44,0,0,0,41.22,12.85Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "55.02 54.44 56.23 56.8 54.95 58.02 51.35 58.23 48.03 56.54 48.92 54.36 51.79 55.27 55.02 54.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.54,54s2.22,2.57,6.88.22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodle);
export default __webpack_public_path__ + "static/media/doodle.46309f5d9cabd6ba410813c03d337e4b.svg";
export { ForwardRef as ReactComponent };